module.exports = "/lucky-balls/img/drum/drum_loop_019.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_019.png
// module id = 1034
// module chunks = 0